import { useCallback } from "react";
import { event } from "../../../analytics";

export const useAnalyticsOnClick = ({
  eventName,
  category = "current_notification"
}) => useCallback(() => event(eventName, category), [eventName, category]);
